// Removed unused React import
import ModelCard from './ModelCard';

// Define models to use
const models = [
  {
    id: 1,
    name: 'Mole pet (santa)',
    modelName: 'Mole',
    description:
      'The Molepet that you can receive from the Mole boss from Old School Runescape.',
    cameraPosition: [75, 120, 350],
    zoom: 2.45,
  },
  {
    id: 2,
    name: 'King Black Dragon',
    modelName: 'KingBlackDragonCentered',
    description: 'The King Black Dragon boss from Old School Runescape.',
    cameraPosition: [55, 80, 500],
    zoom: 0.55,
  },
  {
    id: 3,
    name: 'Alchemical Hydra',
    modelName: 'AlchemicalHydraCentered',
    description: 'The Alchemical Hydra boss from Old School Runescape.',
    cameraPosition: [75, 150, 500],
    zoom: 0.35,
  },
  {
    id: 4,
    name: 'Astronaut',
    modelName: 'Astronaut',
    description: 'Astronaut model',
    cameraPosition: [0, 0, 500],
    zoom: 0.55,
  },
];


function ModelDisplayLayout() {
  return (
    <main className="os-main">
      <section className="os-home-card" style={{ maxWidth: 900 }}>
        <header className="text-center mb-4">
          <h2 className="os-title" style={{ marginBottom: '1rem' }}>3D Models</h2>
          <p className="os-desc">A showcase of custom 3D models from Old School Runescape and more.</p>
        </header>
        <div className="os-models-row" style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'center', alignItems: 'flex-start', width: '100%' }}>
          {models.map((model) => (
            <div key={model.id} className="os-model-card" style={{ flex: '1 1 340px', maxWidth: 400, display: 'flex', justifyContent: 'center' }}>
              <ModelCard modelDetails={model} />
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default ModelDisplayLayout;
